// extracted by mini-css-extract-plugin
export default {"market":"marketPlatform_market__-kJYr","market_content":"marketPlatform_market_content__vxW7s","market_content_item":"marketPlatform_market_content_item__osqbJ"};